// 公共方法：平滑滚动到「申请试用」区块（ApplySection）
// 使用方式：模板中 @click="$scrollToApply" 或 this.$scrollToApply()
export default {
  install(Vue) {
    Vue.prototype.$scrollToApply = function () {
      const el = document.querySelector('.apply-section')
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/scrollToApply.js